// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AppFramePageContent-base__CFNXl{display:flex;flex-direction:column;flex-grow:1;margin-bottom:var(--bottom-bar-height);overflow:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "AppFramePageContent-base__CFNXl"
};
export default ___CSS_LOADER_EXPORT___;
